import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { LogoTypeEnum } from '~/component/logo/enums/logo-type.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { AgeRequirementService } from '~/core/services/activity/age-requirement.service';
import { QrCodeInterface } from '~/organizer/shared/services/qr-code/interfaces/qr-code-interface';
import { QrCodeService } from '~/organizer/shared/services/qr-code/qr-code.service';

@Component({
  selector: 'app-qr-code-validation',
  templateUrl: './qr-code-validation.component.html',
  styleUrls: ['./qr-code-validation.component.scss'],
})
export class QrCodeValidationComponent implements OnDestroy, OnInit {
  private readonly subscriptions = new Subscription();

  public readonly icon = VtmnPlayIconTypeEnum;
  public readonly logoType = LogoTypeEnum;

  public isLoading = true;
  public qrCode: QrCodeInterface;

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: string,
    protected readonly activatedRoute: ActivatedRoute,
    private readonly ageRequirement: AgeRequirementService,
    private readonly translateService: TranslateService,
    private readonly qrCodeService: QrCodeService
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const qrCodeId = this.activatedRoute.snapshot.paramMap.get('id');

      if (qrCodeId) {
        this.isLoading = true;

        this.subscriptions.add(
          this.qrCodeService.postQrCode(qrCodeId).subscribe({
            next: (response) => {
              this.qrCode = response.qrCode;
              this.isLoading = false;
            },
            error: (err) => {
              console.error('Erreur lors de la récupération du QR Code :', err);
              this.isLoading = false;
            },
          })
        );
      }
    }
  }

  public get ageTranslation(): string {
    return this.translateService.instant('organizer_qr_code_validation.child', {
      age: this.qrCode?.age,
    });
  }

  public get displayAge(): boolean {
    return this.qrCode?.age < this.ageRequirement?.tenantMajority;
  }

  public get statusDescription(): string {
    return this.translateService.instant('organizer_qr_code_validation.valid');
  }

  public get statusIcon(): VtmnPlayIconTypeEnum {
    return this.icon.Check;
  }

  public get statusTitle(): string {
    return this.translateService.instant(
      'organizer_qr_code_validation.title.valid'
    );
  }
}
